import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Adresse / localisation — épingle de carte duotone */
export const LocationIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Épingle remplie menthe */}
      <path
        d="M12 2c-4.5 0-8 3.5-8 8 0 5.5 8 12 8 12s8-6.5 8-12c0-4.5-3.5-8-8-8z"
        fill="var(--equiply-icon-bg)" fillOpacity="0.6"
      />
      {/* Contour épingle */}
      <path
        d="M12 2c-4.5 0-8 3.5-8 8 0 5.5 8 12 8 12s8-6.5 8-12c0-4.5-3.5-8-8-8z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Cercle intérieur */}
      <circle cx="12" cy="10" r="3" fill="hsl(var(--background))" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
    </svg>
  ),
);
LocationIcon.displayName = "LocationIcon";
